import { DateTime } from 'luxon';
import { InsightsInterval } from '../../models';

const getDataOverTimeInterval = (startDate: string, endDate: string): InsightsInterval => {
  const startDateTime = DateTime.fromISO(startDate);
  const endDateTime = DateTime.fromISO(endDate);
  const timeFrame = endDateTime.diff(startDateTime, ['years', 'months', 'days']);
  
  const greaterThanOneYear = timeFrame.years >= 1;
  const exactlyOneMonth = timeFrame.months == 1 && timeFrame.days == 0;
  const lessThanOneMonth = timeFrame.days <= 31 && timeFrame.months == 0;
  const exactlySixMonths = timeFrame.months == 6 && timeFrame.days == 0;
  const lessThanSixMonths = timeFrame.months < 6;

  const showDayInterval = (lessThanOneMonth || exactlyOneMonth) && !greaterThanOneYear;
  const showWeeklyInterval = (lessThanSixMonths || exactlySixMonths) && !greaterThanOneYear && !showDayInterval;

  if (showDayInterval) {
    return InsightsInterval.day;
  }
  if (showWeeklyInterval) { 
    return InsightsInterval.week;
  }
  return InsightsInterval.month;

};

export default getDataOverTimeInterval;
